// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/new-car-coverage/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/new-car-coverage/")({
  component: PageComponent,

})

function PageComponent() {
  return <Page />
}
